import BasicInformation from './Info'
import DeliveryInformation from './Delivery'
import PaymentInformation from './Payment'
import PickupInformation from './Pickup'
import ChargesInformation from './Charges'
import StatusLog from './StatusLog'

export {
  BasicInformation,
  DeliveryInformation,
  PaymentInformation,
  PickupInformation,
  ChargesInformation,
  StatusLog
}
